import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  InputBase,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  Stack,
  IconButton,
  Button,
  Menu,
  MenuItem,
  Avatar,
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
  alpha,
} from "@mui/material";
import { Icon } from "@iconify/react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useRequestState } from "@app/hooks";
import { PATH_DASHBOARD } from "@app/routes/paths";
import { Strings } from "@app/constants";
import { AssignCustomerModal } from "./assign-customer-modal";
import { deleteSalesPerson, salesPerson, salesPersonDetails } from "../slice";
import { selectDeleteSalesPerson, selectSalesPersonState } from "../selector";
import { AddSalespersonModal } from "./add-sales-person-popup";
import { EditPersonPopup } from "./edit-person-popup";

const rowsPerPage = 10;

const SalesPersonPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const [page, setPage] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);
  const [openEditPopup, setOpenEditPopup] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRow, setSelectedRow] = useState<number | null>(null);
  const [selectedRowData, setSelectedRowData] = useState<any>(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState<any>(null);

  const { data } = useRequestState({
    stateSelector: selectSalesPersonState,
  });

  const { loading: isDeleting } = useRequestState({
    stateSelector: selectDeleteSalesPerson,
    successMessageShown: true,
    errorShown: true,
    onSuccess: () => {
      setOpenDeleteModal(false);
      setUserToDelete(null);
      dispatch(salesPerson({ role: "User" }));
    },
  });

  console.log(selectedRowData, "dattttt--selectrow");

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, id: number) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleChangePage = (_: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const salesPersonList = Array?.isArray(data) ? data : [];

  const filteredData = salesPersonList?.filter((item) => {
    const fullName = `${item?.firstName || ""} ${
      item?.lastName || ""
    }`.toLowerCase();
    return (
      fullName.includes(searchText.toLowerCase()) ||
      item?.email?.toLowerCase().includes(searchText.toLowerCase()) ||
      item?.phone?.toLowerCase().includes(searchText.toLowerCase()) ||
      item?.role?.toLowerCase().includes(searchText.toLowerCase())
    );
  });

  const paginatedData = filteredData?.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  const handleNavigation = (row: any) => {
    navigate(PATH_DASHBOARD.salesPersonDetails, {
      state: { salesPerson: row },
    });
    dispatch(salesPersonDetails({ id: row?.id }));
  };

  useEffect(() => {
    dispatch(salesPerson({ role: "User" }));
  }, [dispatch]);

  const fontFamily = Strings.fontLanguage.workSans;

  return (
    <Box sx={{ p: 2 }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
        gap={2}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flex: 1,
            backgroundColor: "#fff",
            border: "1px solid #ddd",
            borderRadius: 1,
            px: 2,
            py: 1,
            width: "90%",
          }}
        >
          <Icon
            icon="mdi:magnify"
            style={{ marginRight: 8, color: "#757575" }}
          />
          <InputBase
            fullWidth
            placeholder="Search"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </Box>
        <Button
          variant="contained"
          startIcon={<Icon icon="mdi:plus" />}
          sx={{
            borderRadius: 1,
            textTransform: "none",
            color: "white",
            backgroundColor: theme.palette.primary.main,
          }}
          onClick={() => setOpenAddModal(true)}
        >
          {Strings.salesPerson.addSalesPerson}
        </Button>
      </Stack>
      <Paper>
        <TableContainer>
          <Table>
            <TableHead sx={{ backgroundColor: "#F4F6F8" }}>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{
                    color: "#474747",
                    fontFamily: fontFamily,
                    fontWeight: "600",
                  }}
                >
                  {Strings.dashboard.name}
                </TableCell>

                <TableCell
                  align="center"
                  sx={{
                    color: "#474747",
                    fontFamily: fontFamily,
                    fontWeight: "600",
                  }}
                >
                  {Strings.salesPerson.contact}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    color: "#474747",
                    fontFamily: fontFamily,
                    fontWeight: "600",
                  }}
                >
                  {Strings.salesPerson.email}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    color: "#474747",
                    fontFamily: fontFamily,
                    fontWeight: "600",
                  }}
                >
                  {Strings.salesPerson.role}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    color: "#474747",
                    fontFamily: fontFamily,
                    fontWeight: "600",
                  }}
                >
                  {Strings.salesPerson.customersAssigned}
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    color: "#474747",
                    fontFamily: fontFamily,
                    fontWeight: "600",
                  }}
                >
                  {Strings.dashboard.action}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData?.length > 0 ? (
                paginatedData?.map((row) => (
                  <TableRow
                    key={row?.id}
                    hover
                    sx={{ cursor: "pointer" }}
                    onClick={() => handleNavigation(row)}
                  >
                    {/* <TableCell align="center">
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        gap={1}
                      >
                        <Avatar
                          alt={`${row?.firstName} ${row?.lastName}` || "Avatar"}
                          src={row?.profileImage || ""}
                          sx={{ width: 32, height: 32, fontSize: 14 }}
                        >
                          {!row?.profileImage && row?.firstName
                            ? `${row?.firstName[0]}${
                                row?.lastName?.[0] || ""
                              }`.toUpperCase()
                            : "N"}
                        </Avatar>
                      </Box>
                    </TableCell> */}
                    <TableCell
                      align="center"
                      sx={{
                        color: "#5F5F5F",
                        fontFamily: fontFamily,
                        fontWeight: "500",
                      }}
                    >
                      {row?.firstName || "N/A"}
                    </TableCell>
                    {/* <TableCell
                      align="center"
                      sx={{
                        color: "#5F5F5F",
                        fontFamily: fontFamily,
                        fontWeight: "500",
                      }}
                    >
                      {row?.lastName || "N/A"}
                    </TableCell> */}
                    <TableCell
                      align="center"
                      sx={{
                        color: "#5F5F5F",
                        fontFamily: fontFamily,
                        fontWeight: "500",
                      }}
                    >
                      {row?.phone || "N/A"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        color: "#5F5F5F",
                        fontFamily: fontFamily,
                        fontWeight: "500",
                      }}
                    >
                      {row?.email || "N/A"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        color: "#5F5F5F",
                        fontFamily: fontFamily,
                        fontWeight: "500",
                      }}
                    >
                      {row?.role || "N/A"}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        color: "#5F5F5F",
                        fontFamily: fontFamily,
                        fontWeight: "500",
                      }}
                    >
                      {row?.assignedCustomers?.length || 0}
                    </TableCell>
                    <TableCell
                      align="center"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <IconButton onClick={(e) => handleMenuOpen(e, row.id)}>
                        <Icon icon="mdi:dots-vertical" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={5}
                    align="center"
                    sx={{
                      py: 6,
                      fontSize: "1rem",
                      color: "text.secondary",
                      mt: 4,
                    }}
                  >
                    {Strings.salesPerson.dataNotFound}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 2,
            py: 1,
            borderTop: "1px solid #eee",
            marginLeft: "auto",
          }}
        >
          <Typography variant="body2" sx={{ marginLeft: "auto" }}>
            Showing {(page - 1) * rowsPerPage + 1} to {""}
            {Math.min(page * rowsPerPage, filteredData?.length)} of
            {" " + filteredData?.length} Users
          </Typography>
          <Pagination
            count={Math.ceil(filteredData?.length / rowsPerPage)}
            page={page}
            onChange={handleChangePage}
            color="primary"
            shape="rounded"
            size="small"
            siblingCount={0}
            boundaryCount={1}
            sx={{
              "& .MuiPaginationItem-root": {
                minWidth: 25,
                height: 25,
                fontSize: 14,
              },
              "& .MuiPaginationItem-ellipsis": {
                mx: 1,
              },
              "& .MuiPaginationItem-root.Mui-selected": {
                color: "#fff",
                backgroundColor: "#800000",
                borderRadius: "6px",
                fontWeight: 500,
              },
            }}
          />
        </Box>
      </Paper>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem
          onClick={() => {
            handleMenuClose();
            const rowData = paginatedData.find(
              (item) => item.id === selectedRow
            );
            setSelectedRowData(rowData);
            setOpenEditPopup(true);
          }}
        >
          {Strings.button.edit}
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleMenuClose();
            const rowData = paginatedData?.find(
              (item) => item?.id === selectedRow
            );
            setSelectedRowData(rowData);
            setOpenModal(true);
          }}
        >
          {Strings.button.assignCustomer}
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleMenuClose();
            const rowData = paginatedData.find(
              (item) => item.id === selectedRow
            );
            setUserToDelete(rowData || { id: selectedRow });
            setOpenDeleteModal(true);
          }}
          sx={{ color: "error.main" }}
        >
          {Strings.button.delete}
        </MenuItem>
      </Menu>
      {openModal && (
        <AssignCustomerModal
          open={openModal}
          onClose={() => setOpenModal(false)}
          selectedSalesPerson={selectedRowData}
        />
      )}
      {openAddModal && (
        <AddSalespersonModal
          open={openAddModal}
          onClose={() => setOpenAddModal(false)}
          role={selectedRowData?.role}
        />
      )}
      {openEditPopup && (
        <EditPersonPopup
          open={openEditPopup}
          onClose={() => setOpenEditPopup(false)}
          selectedRowData={{
            id: selectedRowData.id,
            email: selectedRowData.email,
            firstName: selectedRowData.firstName,
            lastName: selectedRowData.lastName,
            phone: selectedRowData.phone,
            role: selectedRowData.role,
            profileImage: selectedRowData.profileImage || null,
          }}
        />
      )}

      {/* ------------------------------------------------------------- */}
      {/* DELETE USER CONFIRMATION POPUP */}
      {/* ------------------------------------------------------------- */}
      <Dialog
        open={openDeleteModal}
        onClose={() => !isDeleting && setOpenDeleteModal(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            p: 1,
          },
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography
              variant="h6"
              sx={{
                fontFamily: "Poppins",
                fontWeight: 600,
                color: "#101828",
              }}
            >
              Delete User
            </Typography>
            <IconButton
              disabled={isDeleting}
              onClick={() => {
                setOpenDeleteModal(false);
                setUserToDelete(null);
              }}
              size="small"
              sx={{ color: theme.palette.grey[500] }}
            >
              <Icon icon="mdi:close" style={{ fontSize: 20 }} />
            </IconButton>
          </Stack>
        </DialogTitle>

        <DialogContent sx={{ pt: 1 }}>
          <DialogContentText
            sx={{
              mb: 2,
              fontFamily,
              color: "#474747",
              fontSize: "0.9rem",
              lineHeight: 1.5,
            }}
          >
            Are you sure you want to delete this user? This action cannot be undone.
          </DialogContentText>

          {userToDelete && (
            <Paper
              elevation={0}
              sx={{
                p: 2,
                borderRadius: 1.5,
                backgroundColor: theme.palette.grey[50],
                border: `1px solid #E0E0E0`,
              }}
            >
              <Stack spacing={1.2}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <Typography variant="body2" sx={{ fontFamily, color: "#5F5F5F", fontWeight: 500 }}>
                    Name:
                  </Typography>
                  <Typography variant="body2" sx={{ fontFamily, color: "#101828", fontWeight: 600 }}>
                    {[userToDelete?.firstName, userToDelete?.lastName].filter(Boolean).join(" ") ||
                      userToDelete?.email?.split("@")[0] ||
                      `#${userToDelete?.id}`}
                  </Typography>
                </Stack>
                {userToDelete?.email && (
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="body2" sx={{ fontFamily, color: "#5F5F5F", fontWeight: 500 }}>
                      Email:
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily, color: "#101828", fontWeight: 600 }}>
                      {userToDelete.email}
                    </Typography>
                  </Stack>
                )}
                {userToDelete?.phone && (
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="body2" sx={{ fontFamily, color: "#5F5F5F", fontWeight: 500 }}>
                      Contact No.:
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily, color: "#101828", fontWeight: 600 }}>
                      {userToDelete.phone}
                    </Typography>
                  </Stack>
                )}
                {userToDelete?.role && (
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="body2" sx={{ fontFamily, color: "#5F5F5F", fontWeight: 500 }}>
                      Role:
                    </Typography>
                    <Typography variant="body2" sx={{ fontFamily, color: theme.palette.primary.main, fontWeight: 700 }}>
                      {userToDelete.role}
                    </Typography>
                  </Stack>
                )}
              </Stack>
            </Paper>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2, pt: 1, gap: 1.5 }}>
          <Button
            variant="outlined"
            onClick={() => {
              setOpenDeleteModal(false);
              setUserToDelete(null);
            }}
            disabled={isDeleting}
            sx={{
              flex: 1,
              borderRadius: 1,
              textTransform: "none",
              fontFamily,
              fontWeight: 600,
              borderColor: theme.palette.primary.main,
              color: theme.palette.primary.main,
              "&:hover": {
                borderColor: theme.palette.primary.dark,
                backgroundColor: alpha(theme.palette.primary.main, 0.04),
              },
            }}
          >
            {Strings.button.cancel}
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              if (userToDelete?.id) {
                dispatch(deleteSalesPerson({ salesPersonId: userToDelete.id }));
              }
            }}
            disabled={isDeleting}
            startIcon={
              isDeleting ? (
                <CircularProgress size={16} color="inherit" />
              ) : null
            }
            sx={{
              flex: 1,
              borderRadius: 1,
              textTransform: "none",
              fontFamily,
              fontWeight: 600,
              backgroundColor: theme.palette.primary.main,
              color: "white",
              "&:hover": {
                backgroundColor: theme.palette.primary.dark,
              },
            }}
          >
            {isDeleting ? "Deleting..." : Strings.button.delete}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
export { SalesPersonPage };
